<template>
    <div class="courier_aggregator">
        <div ref="svgContainer" class="courier_aggregator_icon">
        </div>
        <div class="courier_aggregator_title">
            {{ title }}
        </div>
<!--        <div class="courier_aggregator_radio">-->
<!--            <radio_custom-->
<!--                :key="'radio_custom_' + itemAggregator.id"-->
<!--                :radioChecked = "itemAggregator.isSelect"-->
<!--                :radioName="'aggregators'"-->
<!--                :radioValue="itemAggregator.id"-->
<!--                @select_radio_button="selectRadio"-->
<!--            />-->
<!--        </div>-->
    </div>
</template>

<script>

import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import insertSvg from "../../../mixins/insertSvg";
import radio_custom from "../../RadioCustom.vue";

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})


export default {
    name: "courier_aggregator_block",
    props: {
        itemAggregator: {
            type: Object,
            required: true,
        },
    },
    mixins: [insertSvg, screenSize],
    components: {radio_custom},
    emits: ['click_select_aggregator'],
    mounted() {
        if (this.itemAggregator.icon) {
            this.insertSvg(this.itemAggregator.icon);
        }
    },
    methods: {
        selectRadio(radioValue){
            this.$emit('click_select_aggregator', this.itemAggregator);
        }
    },
    computed: {
        title() {
            if(this.itemAggregator.title) {
                return this.itemAggregator.title;
            }
            return 'No title';
        }
    }
}
</script>
